window.deleteFormatter = function(value, row) {
    let html = '';
    if (row.allow_delete === "0") {
        return html;
    }
    html += '<button class="action action-destroy btn btn-danger btn-sm" data-id="' + row.id + '">';
    html += '<i class="fal fa-times me-2"></i>';
    html += __('Verwijderen');
    html += '</button>';
    return html;
};
